import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BlogTableOfContents from './BlogTableOfContents';
import type { TocItem } from '@/hooks/useBlogDetail';

export default function BlogSidebar({ toc }: { toc: TocItem[] }) {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col gap-4 lg:sticky lg:top-24 lg:w-[340px] lg:shrink-0">
      <BlogTableOfContents toc={toc} />

      <div className="relative overflow-hidden rounded-[16px] bg-gradient-to-br from-primary-600 to-primary-800 p-[22px_22px_20px] text-white">
        <span
          aria-hidden
          className="absolute -bottom-10 -right-[34px] size-[140px] rounded-full bg-white/[0.07]"
        />
        <span className="relative inline-block text-[10px] font-bold uppercase tracking-[0.13em] text-white/[0.72]">
          Vietnam Story
        </span>
        <h4 className="relative mt-[11px] text-[17px] font-extrabold leading-[1.3] tracking-[-0.015em]">
          {t('blog.sidebarTitle')}
        </h4>
        <p className="relative mt-2 text-[12.8px] leading-[1.6] text-white/90">
          {t('blog.sidebarText')}
        </p>
        <Link
          className="group relative mt-[17px] flex w-full items-center justify-center gap-[7px] rounded-[11px] bg-white py-3 text-[13.5px] font-bold text-primary-700 transition-all duration-150 hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(0,0,0,0.2)]"
          to="/tours"
        >
          {t('blog.exploreTours')}
        </Link>
        <Link
          className="relative mt-[11px] block text-center text-[12px] font-semibold text-white/90 transition-colors hover:text-white hover:underline"
          to="/contact"
        >
          {t('blog.contactExpert')} →
        </Link>
      </div>
    </div>
  );
}